import { render } from "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=template&id=62358b6e&scoped=true"
import script from "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=script&lang=js"
export * from "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=script&lang=js"

import "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=style&index=0&id=62358b6e&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62358b6e"]])

export default __exports__